import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/page-contact/page-contact-view.tsx");
